import { compose, withProps } from 'recompose';
import TextInput from '../../../se/components/inputs/TextInput';

export default compose(withProps({ placeholder: 'Start typing to filter...' }))(TextInput);
